<template>
  <div class="ct-example-box">
    <dl>
      <dt>{{ $t('Format') }}</dt>
      <dd>
        <!-- apa6 -->
        <div v-if="selectStyle === 'apa6'">
          <span class="highlight--pink">{{ $t('Author Last Name') }}</span>, <span class="highlight--blue">{{ $t('Author First Initial') }}</span> <span class="highlight--yellow">{{ $t('Author Middle Initial') }}</span>. (<span class="highlight--light-purple">{{ $t('Date Published') }}</span>). <span class="highlight--light-green">{{ $t('Page Title') }}</span>. Retrieved <span class="highlight--pink">{{ $t('Date Accessed') }}</span>, from <span class="highlight--blue">URL</span>
        </div>

        <!-- apa7 -->
        <div v-if="selectStyle === 'apa7'">
          <span class="highlight--pink">{{ $t('Author Last Name') }}</span>, <span class="highlight--blue">{{ $t('Author First Initial') }}</span> <span class="highlight--yellow">{{ $t('Author Middle Initial') }}</span>. (<span class="highlight--light-purple">{{ $t('Date Published') }}</span>). <span class="highlight--light-green"><i>{{ $t('Page Title') }}</i></span>. <span class="highlight--pink">{{ $t('Website Name') }}</span>. <span class="highlight--blue">URL</span>
        </div>

        <!-- mla7 -->
        <div v-if="selectStyle === 'mla7'">
          <span class="highlight--pink">{{ $t('Author Last Name') }}</span>, <span class="highlight--blue">{{ $t('Author First Name') }}</span> <span class="highlight--yellow">{{ $t('Author Middle Name') }}</span>. “<span class="highlight--light-purple">{{ $t('Page Title') }}</span>.” <i class="highlight--light-green">{{ $t('Website Name') }}</i>. <span class="highlight--pink">{{ $t('Publisher Name') }}</span>. <span class="highlight--blue">{{ $t('Date Published') }}</span>. Web. <span class="highlight--pink">{{ $t('Date Accessed') }}</span>.
        </div>

        <!-- mla8 -->
        <div v-if="selectStyle === 'mla8'">
          <span class="highlight--pink">{{ $t('Author Last Name') }}</span>, <span class="highlight--blue">{{ $t('Author First Name') }}</span> <span class="highlight--yellow">{{ $t('Author Middle Name') }}</span>. “<span class="highlight--light-purple">{{ $t('Page Title') }}</span>.” <i class="highlight--light-green">{{ $t('Website Name') }}</i>, <span class="highlight--pink">{{ $t('Publisher Name') }}</span>, <span class="highlight--blue">{{ $t('Date Published') }}</span>, <span class="highlight--pink">URL</span>.
        </div>

        <!-- chicago17 -->
        <div v-if="selectStyle === 'chicago17'">
          <span class="highlight--pink">{{ $t('Author Last Name') }}</span>, <span class="highlight--blue">{{ $t('Author First Name') }}</span> <span class="highlight--yellow">{{ $t('Author Middle Name') }}</span>. “<span class="highlight--light-purple">{{ $t('Page Title') }}</span>.” <span class="highlight--light-green">{{ $t('Website Name') }}</span>, <span class="highlight--pink">{{ $t('Date Published') }}</span>, <span class="highlight--blue">URL</span>.
        </div>

        <!-- vancouver -->
        <div v-if="selectStyle === 'vancouver'">
          <span class="highlight--pink">{{ $t('Author Last Name') }}</span>, <span class="highlight--blue">{{ $t('Author First Initial') }}</span> <span class="highlight--yellow">{{ $t('Author Middle Initial') }}</span>. <span class="highlight--light-purple">{{ $t('Page Title') }}</span> [Internet]. <span class="highlight--light-green">{{ $t('Website Name') }}</span>. <span class="highlight--pink">{{ $t('Published Year') }}</span> [cited <span class="highlight--blue">{{ $t('Date Accessed') }}</span>]. Available from: <span class="highlight--pink">URL</span>
        </div>
      </dd>
    </dl>
    <dl>
      <dt>{{ $t('Example') }}</dt>
      <dd>
        <!-- apa6 -->
        <span v-if="selectStyle === 'apa6'">
                  Kim, A. (2020, August 28). How I Became a Full-Time Freelance Editor (and How You Can, Too). Retrieved September 4, 2020, from https://medium.com/wordviceediting/how-i-became-a-full-time-freelance-editor-and-how-you-can-too-7e694d1792bc
              </span>

        <!-- apa7 -->
        <span v-if="selectStyle === 'apa7'">
                  Kim, A. (2020, August 28). <i>How I Became a Full-Time Freelance Editor (and How You Can, Too)</i>. Medium. https://medium.com/wordviceediting/how-i-became-a-full-time-freelance-editor-and-how-you-can-too-7e694d1792bc
              </span>

        <!-- mla7 -->
        <span v-if="selectStyle === 'mla7'">
                  Kim, Andrew. “How I Became a Full-Time Freelance Editor (and How You Can, Too).” <i>Medium</i>. Medium, 28 Aug. 2020. Web. 9 Sept. 2020.
              </span>

        <!-- mla8 -->
        <span v-if="selectStyle === 'mla8'">
                  Kim, Andrew. “How I Became a Full-Time Freelance Editor (and How You Can, Too).” <i>Medium</i>, Medium, 28 Aug. 2020, medium.com/wordviceediting/how-i-became-a-full-time-freelance-editor-and-how-you-can-too-7e694d1792bc.
              </span>

        <!-- chicago17 -->
        <span v-if="selectStyle === 'chicago17'">
                  Kim, Andrew. “How I Became a Full-Time Freelance Editor (and How You Can, Too).” Medium, August 28, 2020. https://medium.com/wordviceediting/how-i-became-a-full-time-freelance-editor-and-how-you-can-too-7e694d1792bc.
              </span>

        <!-- vancouver -->
        <span v-if="selectStyle === 'vancouver'">
                  1. Kim A. How I Became a Full-Time Freelance Editor (and How You Can, Too) [Internet]. Medium. 2020 [cited 2020 Sep 9]. Available from: https://medium.com/wordviceediting/how-i-became-a-full-time-freelance-editor-and-how-you-can-too-7e694d1792bc
              </span>
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: "webpage_help",
  props: ["selectStyle"],
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/generator-example/webpage.vue